import { useAuth as useClerkAuth } from '@clerk/react'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'

import { usePortfolioAdminWithoutPortfolio } from '@/components/hooks/usePortfolioAdminWithoutPortfolio'
import { useAccessPermissions } from '@/hooks/useAccessPermissions'
import { useAuth } from '@/hooks/useAuth'
import { useOrganizationRole } from '@/hooks/useOrganizationRole'

export const useLoggedOutRoute = () => {
  const { isSignedIn } = useClerkAuth()
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const {
    activeOrganizationId: organizationId,
    isOrganizationLoading: isAccessLoading,
    hasAdminOrganizationMembership,
  } = useAccessPermissions()
  const { isOrgActive, hasOrgMembership, isOrgAdmin } = useOrganizationRole()

  const [isHandlingDisabledOrg, setIsHandlingDisabledOrg] = useState(false)
  const hasAttemptedDisabledOrgSignOut = useRef(false)

  usePortfolioAdminWithoutPortfolio({
    organizationId,
    user,
  })

  useEffect(() => {
    if (!isSignedIn || !user || isAccessLoading || isHandlingDisabledOrg) {
      return
    }

    if (hasOrgMembership && !isOrgActive && !isOrgAdmin) {
      if (hasAttemptedDisabledOrgSignOut.current) {
        return
      }

      hasAttemptedDisabledOrgSignOut.current = true
      setIsHandlingDisabledOrg(true)

      const handleDisabledOrganizationSignOut = async () => {
        try {
          await signOut()
        } catch (error) {
          console.error('Failed to sign out', error)
        }

        window.location.href = '/?error=organization-disabled'
      }

      void handleDisabledOrganizationSignOut()
      return
    }

    const redirectToPortfolioOnboarding = sessionStorage.getItem(
      'redirectToPortfolioOnboarding'
    )

    if (redirectToPortfolioOnboarding) {
      sessionStorage.removeItem('redirectToPortfolioOnboarding')
      navigate('/onboarding/portfolio', {
        replace: true,
        state: { fromInvitation: true },
      })
      return
    }

    navigate(hasAdminOrganizationMembership ? '/organizations' : '/holding', {
      replace: true,
    })
  }, [
    isSignedIn,
    user,
    isAccessLoading,
    isHandlingDisabledOrg,
    hasAdminOrganizationMembership,
    hasOrgMembership,
    isOrgActive,
    isOrgAdmin,
    navigate,
    signOut,
  ])

  return {
    isSignedIn,
    isHandlingDisabledOrg,
  }
}
